// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__okWJe","search":"Settings_search__3tXC5","filter":"Settings_filter__1bUWm"};